<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-deal`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 24c0 12.15 9.85 22 22 22s22-9.85 22-22S36.15 2 24 2 2 11.85 2 24zm4 0c0-9.941 8.059-18 18-18s18 8.059 18 18-8.059 18-18 18S6 33.941 6 24zm4.953 5.73l.1.113 6.828 7.107a1 1 0 001.39.05l.088-.09 1.155-1.339a1 1 0 00.046-1.248l-.082-.098-3.682-3.832H36.5a1 1 0 00.993-.884l.007-.116V27.5a1 1 0 00-.883-.993L36.5 26.5H12.319c-1.599 0-2.376 2.01-1.366 3.23zM10.5 20.5a1 1 0 001 1h24.181c1.649 0 2.424-2.138 1.266-3.343L30.12 11.05c-.033-.034-.033-.034-.069-.065a1 1 0 00-1.41.105l-1.154 1.339a1 1 0 00.036 1.346l3.681 3.832H11.5a1 1 0 00-1 1V20.5z"/></svg>
</template>
<script>

export default {
  name: 'IconDeal',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
